














































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { GetTerms } from "@/request/projects";
import { PostShemianmaiSousuo } from "@/request/model";
@Component({})
export default class ModelTrailBiaodan extends Vue {
  @Prop()
  private message: any;
  @Prop()
  private model: any;
  private kexias: any[] = [];
  private shezhis: any[] = [];
  private shetais: any[] = [];
  private mianses: any[] = [];
  private maixiangs: any[] = [];
  private zhenduans: any[] = [];
  private zhengxings: any[] = [];
  /**
   * @description 刻下症搜索
   */
  private fetchKexias(value) {
    const params: any = {
      params: {
        type: "中医症状",
        search: value
      }
    };
    GetTerms(this, params).then((data: any) => {
      if (
        this.message.info["刻下症"] &&
        this.message.info["刻下症"].length > 0
      ) {
        this.kexias = _.uniqBy(data.concat(this.message.info["刻下症"]), "id");
      } else {
        this.kexias = data;
      }
    });
  }
  /**
   * @description 舌质搜索
   */
  private fetchShezhis(value) {
    const params: any = {
      type: "舌质",
      症状: value
    };
    PostShemianmaiSousuo(this, params).then((data: any) => {
      if (this.message.info["舌质"] && this.message.info["舌质"].length > 0) {
        this.shezhis = _.uniqBy(data.concat(this.message.info["舌质"]), "id");
      } else {
        this.shezhis = data;
      }
    });
  }
  /**
   * @description 舌苔搜索
   */
  private fetchShetais(value) {
    const params: any = {
      type: "舌苔",
      症状: value
    };
    PostShemianmaiSousuo(this, params).then((data: any) => {
      if (this.message.info["舌质"] && this.message.info["舌苔"].length > 0) {
        this.shetais = _.uniqBy(data.concat(this.message.info["舌苔"]), "id");
      } else {
        this.shetais = data;
      }
    });
  }
  /**
   * @description 面色搜索
   */
  private fetchMianses(value) {
    const params: any = {
      type: "面色",
      症状: value
    };
    PostShemianmaiSousuo(this, params).then((data: any) => {
      if (this.message.info["面色"] && this.message.info["面色"].length > 0) {
        this.mianses = _.uniqBy(data.concat(this.message.info["面色"]), "id");
      } else {
        this.mianses = data;
      }
    });
  }
  /**
   * @description 脉象搜索
   */
  private fetchMaixiangs(value) {
    const params: any = {
      type: "脉象",
      症状: value
    };
    PostShemianmaiSousuo(this, params).then((data: any) => {
      if (this.message.info["脉象"] && this.message.info["脉象"].length > 0) {
        this.maixiangs = _.uniqBy(data.concat(this.message.info["脉象"]), "id");
      } else {
        this.maixiangs = data;
      }
    });
  }
  /**
   * @description 中医诊断搜索
   */
  private fetchZhenduans(value) {
    const params: any = {
      params: {
        type: "中医疾病",
        search: value
      }
    };
    GetTerms(this, params).then((data: any) => {
      if (
        this.message.info["中医诊断"] &&
        this.message.info["中医诊断"].length > 0
      ) {
        this.zhenduans = _.uniqBy(
          data.concat(this.message.info["中医诊断"]),
          "id"
        );
      } else {
        this.zhenduans = data;
      }
    });
  }
  /**
   * @description 中医证型搜索
   */
  private fetchZhengxings(value) {
    const params: any = {
      params: {
        type: "中医证型",
        search: value
      }
    };
    GetTerms(this, params).then((data: any) => {
      if (
        this.message.info["中医证型"] &&
        this.message.info["中医证型"].length > 0
      ) {
        this.zhengxings = _.uniqBy(
          data.concat(this.message.info["中医证型"]),
          "id"
        );
      } else {
        this.zhengxings = data;
      }
    });
  }
}
